import { Component } from '@angular/core';
import {
    Data, Subscription, PriceCalculationService, SummaryService,
    DataLoaderService, ProgressBarService, CommonDataService, SortingService
} from '../expert-screen-components/expert-service-call.index';
import * as _ from 'lodash';
import { VehicleInfoService } from '../../../services/vehicle-info.service';

@Component({
    selector: 'initial-alternate-popup',
    templateUrl: './initial-alternate-options.template.html',
    styleUrls: ['./initial-alternate-options.component.css'],
})
export class InitialAlternateScreenComponent {
    public packageEquipments = [];
    public suggestionList = [];
    public subscription: Subscription;
    public selectCode: any;
    public selectedItem: Data[] = [];
    public colorOptions = [];
    public addColorOptions = [];
    public rim = [];
    public upholstery = [];
    public otherCodesInitialList = [];
    public trim = [];
    public factoryOptions: Data[];
    public additionalColorOptions: Data[];
    public packageOptions: Data[];
    public localOptions: Data[];
    public localPackageOptions: Data[];
    public standardOptions: Data[];
    public icon = "gray";
    public acceptFlag: boolean = false;
    public errorMessage: any;
    public tempSuggestionList = [];
    private alternateFactory: Data[] = [];
    private alternateLocal: Data[] = [];
    private alternatePackage: Data[] = [];
    private alternateLocalPackage: Data[] = [];
    private alternateStandard: Data[] = [];
    private selectedIndex: string = "item";
    private equipmentList: string;
    private showAcceptMandatory: boolean;
    public addedMsgs: any;
    public deletedMsgs: any;
    public addedCodes: any;
    public deletedCodes: any;
    public otherCodesInitial: any;
    public initialList: any;

    constructor(private priceCalculationService: PriceCalculationService, private sortingService: SortingService,
        private dataLoaderService: DataLoaderService, private progressBarService: ProgressBarService,
        private commonDataService: CommonDataService, private summaryService: SummaryService,private vehicleInfoService: VehicleInfoService) {
    }

    ngAfterContentInit() {
        this.getAlternateOptions();
    }

    selectedCode(item, index) {
        if(this.dataLoaderService.vehicleInfo.urlFlag == '2'){
        this.commonDataService.suggestDataList= this.dataLoaderService.data.validationResponse;
        for (let i in this.commonDataService.suggestDataList) {
            if (this.commonDataService.suggestDataList[i].flagSelected === true) {
                this.commonDataService.suggestDataList[i].flagSelected = false;
            }
        }
        this.dataLoaderService.data.validationResponse.flagSelected = true;
    }
}
    /**
     * To get the alternate options for a particular package option from service
     * @param index
     * @returns none
     */
    getAlternateOptions() {
            if (this.dataLoaderService.data.validationResponse) {
                const added = this.dataLoaderService.data.validationResponse.addedCodes || [];
                const deleted = this.dataLoaderService.data.validationResponse.deletedCodes || [];

                var tempAdded = added.length;
                var tempDeleted = deleted.length;
            }
            this.initialList= tempAdded+tempDeleted;
            
        }
        initialAcceptSuggestion() {
            this.otherCodesInitial = JSON.parse(this.dataLoaderService.vehicleInfo.savedConfig).otherCodes;
            let f=false;
            const deleted = this.dataLoaderService.data.validationResponse.deletedCodes || [];
           for(let i=0;i < this.otherCodesInitial.length;i++){
                f=false;
               for(let j=0;j<deleted.length;j++){
               if(this.otherCodesInitial[i] === this.dataLoaderService.data.validationResponse.deletedCodes[j].code)
                {
                    f=true;
                }
               }
               if(f===false){
                this.otherCodesInitialList.push(this.otherCodesInitial[i]);
            }
           }

           const added = this.dataLoaderService.data.validationResponse.addedCodes || [];

           for(let i=0;i < added.length;i++){
           this.otherCodesInitialList.push(this.dataLoaderService.data.validationResponse.addedCodes[i].code);
           }
            var stringtojson =  JSON.parse(this.dataLoaderService.vehicleInfo.savedConfig);
            var newjson = stringtojson["otherCodes"];
            stringtojson["otherCodes"] = this.otherCodesInitialList;
        
            this.dataLoaderService.vehicleInfo.savedConfig = "";
            this.dataLoaderService.vehicleInfo.savedConfig = JSON.stringify(stringtojson);
            this.progressBarService.illuminateGreen();
            this.dataLoaderService.flagDictionary.displayInitialAlternative = false;
        }
       
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/initial-alternate-options/initial-alternate-options.component.ts